import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { palette } from "../../assets/theme/theme";
import { PropConfig } from "../../types/EntityConfig";
import HorizontalRule from "../HorizontalRule/HorizontalRule";
import { buildEndpoint } from "../../services/api.service";



export const CustomParagraph = ({ prop, type, displayInfo, routable, options, data, tableConfigs, displayFunction }: any) => {

    const navigate = useNavigate();

    const [hovered, setHovered] = useState(false);

    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);



    const getNestedValue = (option: any, labelKey: string) => {
        const keys: string[] = labelKey.split('.');
        for (let key of keys) {
            if (!option[key]) return "";
            option = option[key];
        }
        return option;
    }

    const getValueToDisplay = () => {

        if (displayFunction) {
            console.log("Data is: ", data);
            return displayFunction(data);
        }

        if (type === 'select') {
            return displayValue(data) ? displayValue(getNestedValue(data, options.label)) : null
        } else if (type === 'multi-select') {
            let vals = [];
            if (data?.length > 0) {
                data.forEach((a: any) => {
                    vals.push(`${a[options.label]}`);
                })
            }


            return displayValue(data);
        } else if (type === 'boolean') {
            return data ? 'Sim' : 'Não';
        } else if (type === 'multiple-create') {
            if (data)
                return (
                    <div className="w-full">
                        {data.map((d: any, i: number) => {
                            return (<div className="border-2 border-zinc-400 p-1 rounded-lg mb-1">
                                <div key={i} className="flex w-full justify-between">
                                    {options.subFormConfig
                                        .filter((c: PropConfig) => !c.hidden).filter((a: PropConfig) => a.id != 'id' && a.type != 'multiple-create')
                                        .filter((tc: PropConfig) => {
                                            return d[tc.id] !== null && d[tc.id] !== undefined;
                                        })
                                        .map((sp: PropConfig, i2: number) => {
                                            return (<><CustomParagraph
                                                key={i2}
                                                prop={sp.label}
                                                type={sp.type}
                                                displayInfo={sp.displayInfo}
                                                routable={sp.routable}
                                                options={sp.options}
                                                data={d[sp.id]}
                                                tableConfigs={options.subFormConfig}
                                                isSubForm
                                            />

                                            </>)
                                        })}

                                </div>
                                <div>
                                    {options.subFormConfig
                                        .filter((c: PropConfig) => !c.hidden)
                                        .filter((a: PropConfig) => a.id != 'id' && a.type == 'multiple-create')
                                        .map((sp: PropConfig, i2: number) => {
                                            return (<><CustomParagraph
                                                key={i2}
                                                prop={sp.label}
                                                type={sp.type}
                                                displayInfo={sp.displayInfo}
                                                routable={sp.routable}
                                                options={sp.options}
                                                data={d[sp.id]}
                                                tableConfigs={options.subFormConfig}
                                                isSubForm
                                            />

                                            </>)
                                        })}

                                </div>
                                {/* <HorizontalRule style={{ borderColor: palette.gray.medium }} /> */}

                            </div>)
                        })}
                    </div>
                )

        } else if (type === 'anexos') {
            
            if (data) {
                console.log("Options:: ", options);
                const config = tableConfigs.find((tc: PropConfig) => tc.id == prop);
                console.log("COnfig: ", config);
                return (data.map((d: any, i: number) => {
                    return (<div key={i} className="flex w-full">
                        <a className="p-2" href={`${buildEndpoint(options.anexosEndpointBuildFunction(undefined))}/download/${d.id}`} download target='__blank'>
                            <div className="w-fit cursor-pointer mt-2 underline hover:no-underline" >{d.name}</div>
                        </a>
                        {/* <div className="font-bold mr-1">{d.name}</div> */}
                    </div>)
                }))
            }
        } else {
            return displayValue(data);
        }

    }



    const displayValue = (input: any) => {

        if (!input)
            return ""
        if (Array.isArray(input)) {
            return (
                <div> {(input.map((i, idx) => {
                    const str = idx < input.length - 1 ? `${i[options.label]}, ` : `${i[options.label]}`;
                    return <span
                        key={i.id}
                        className={`${routable ? 'cursor-pointer underline' : ''} hover:text-[#c02d1a]`}
                        onMouseEnter={() => routable ? setHoveredIndex(idx) : null} onMouseLeave={() => routable ? setHoveredIndex(null) : null}
                        onClick={() => {
                            if (routable) {
                                navigate('/' + options.route + '/' + i.id, { state: { entityName: options.name, idProp: options.label } });
                                setHoveredIndex(null);
                            }
                        }}>
                        {str}
                    </span>
                }))}
                </div>
            )
        }

        let val;
        switch (displayInfo) {
            case 'currency':
                val = input + '€';
                break;
            case 'percentage':
                val = input + '%';
                break;
            default:
                val = input + (displayInfo ? ` (${displayInfo})` : '');
                break;
        }

        return (<span
            style={{ cursor: routable ? 'pointer' : null, textDecoration: routable ? 'underline' : null, color: hovered ? '#c02d1a' : null } as any}
            onMouseEnter={() => routable ? setHovered(true) : null} onMouseLeave={() => routable ? setHovered(false) : null}
            onClick={() => {
                if (routable) {
                    navigate('/' + options.route + '/' + data.id, { state: { entityName: options.name, idProp: options.label } });
                    setHovered(false);
                }
            }}>
            {val}
        </span>)

    }


    return (<>
        <div className={`${type != 'multiple-create' ? 'flex' : ''} m-5 w-auto justify-between items-center content-center text-md`}>
            <div className={`font-bold mr-1 ${type == 'multiple-create' ? 'mb-1' : ''}`}>{prop}: </div>
            <div className="whitespace-pre-line ">{getValueToDisplay()}</div>
        </div>
    </>)
}
